// extracted by mini-css-extract-plugin
export var createdDate = "_lr-1";
export var divider = "_lr-2";
export var headerDivider = "_lr-3";
export var messagesCard = "_lr-0";
export var messagesContainer = "_lr-6";
export var messagesContainerWrapper = "_lr-4";
export var showLeftPanelButton = "_lr-8";
export var topButtons = "_lr-7";
export var withPadding = "_lr-5";